import dayjs from "dayjs"
import { SelectDataType } from "src/components/atom/SelectDataType"

export const getWeekDayString = (date: string | undefined) => {
  if (!date) {
    return ""
  }

  const thValue = Math.ceil(dayjs(date).date() / 7)
  let weekDay = ""
  switch (dayjs(date).day()) {
    case 0:
      weekDay = "日曜"
      break
    case 1:
      weekDay = "月曜"
      break
    case 2:
      weekDay = "火曜"
      break
    case 3:
      weekDay = "水曜"
      break
    case 4:
      weekDay = "木曜"
      break
    case 5:
      weekDay = "金曜"
      break
    case 6:
      weekDay = "土曜"
      break
  }
  return `第${thValue}${weekDay}`
}

export const getFormattedDateString = (date: string | undefined) => {
  if (!date) {
    return ""
  }

  return `${dayjs(date).year()}年${dayjs(date).month() + 1}月${dayjs(
    date
  ).date()}日 ${getWeekDayString(date)}`
}

export const getLabel = (datas: SelectDataType[], value: number) => {
  for (const data of datas) {
    if (data.value === value) {
      return data.label
    }
  }
  return ""
}
